export const RESOURCE_COORDINATOR_URL = '/secure/index/social-care'
export const NICOTINE_QUITLINE_URL = '/secure/index/nicotine-quitline'
export const GOOGLE_PERFORMANCE_URL = '/secure/index/performance'
